import { render, staticRenderFns } from "./CreateByType.vue?vue&type=template&id=140ead11"
var script = {}
import style0 from "./CreateByType.vue?vue&type=style&index=0&id=140ead11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports